const skillsCoding = [
    { text: 'C#', icon: 'skill_advanced.png'},
    { text: 'Java', icon: 'skill_beginner.png'},
    { text: 'Javascript', icon: 'skill_intermediate.png'},
    { text: 'UE4 Blueprint', icon: 'skill_intermediate.png'},
    { text: 'HTML', icon: 'skill_intermediate.png'},
    { text: 'CSS', icon: 'skill_intermediate.png'},
    { text: 'Vue.js', icon: 'skill_beginner.png'},
  ];
  
  export default skillsCoding;